import discountsApi from "../../api/discounts";

const emptyDiscount = {
  storeId: null,

  logo: null,
  title: "",
  description: "",
  start: "",
  end: ""
};

const state = () => ({
  cityId: null,

  id: null,
  data: emptyDiscount
});

const getters = {};

const actions = {
  create({ state }) {
    return discountsApi.create(state.data);
  },

  fetchOne({ state }, discountId) {
    return new Promise((resolve, reject) =>
      discountsApi
        .getOne(discountId)
        .then(result => {
          state.id = result._id;
          delete result._id;

          state.cityId = result.cityId;
          delete result.cityId;
          delete result.cityName;

          delete result.storeName;

          state.data = result;
          resolve();
        })
        .catch(e => reject(e))
    );
  },

  save({ state }) {
    return discountsApi.update(state.id, state.data);
  }
};

const mutations = {
  clear(state) {
    state.id = null;
    state.data = emptyDiscount;
  },

  setCity(state, cityId) {
    state.cityId = cityId;
  },

  setStore(state, storeId) {
    state.data.storeId = storeId;
  },

  setLogo(state, logo) {
    state.data.logo = logo;
  },
  setTitle(state, title) {
    state.data.title = title;
  },
  setDescription(state, description) {
    state.data.description = description;
  },
  setStart(state, start) {
    state.data.start = start;
  },
  setEnd(state, end) {
    state.data.end = end;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
